<div class="container modal-definir-conta">
    <div class="row">
        <div class="col-lg-12 mr-auto ml-auto">
            <div>
                <h4 class="title mt-0">Identificamos que você ainda não definiu o seu perfil de usuário!</h4>
                <p>Selecione um perfil abaixo para logar no sistema como...</p>
                <div class="text-center">
                    <button (click)="definirConta('candidato')" class="btn btn-candidato btn-block">Candidato</button>
                    <button (click)="definirConta('empresa')" class="btn btn-empresa btn-block">Empresa</button>
                </div>
            </div>
        </div>
    </div>
</div>
